// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
    apiKey: "AIzaSyB0Z2inO7yn5Ny0U--GNhx-HNYPdF8GZEI",
    authDomain: "ec-app-a2afb.firebaseapp.com",
    projectId: "ec-app-a2afb",
    storageBucket: "ec-app-a2afb.appspot.com",
    messagingSenderId: "815896748373",
    appId: "1:815896748373:web:c41e796eff4907e10c0fdc",
    measurementId: "G-7LRDC2EZZ6"
  };